import { StateCreator } from "zustand";

export type UserManagementSlice = {
  userManagementUsers: {
    [accountId: string]: {
      name: string;
      email: string;
      updatedAt: string;
      status: "Active" | "Pending" | "Inactive";
      role: "Viewer" | "Operator" | "Admin";
    }[];
  };
  setUserManagementUsers: (
    accountId: string,
    users: {
      name: string;
      email: string;
      updatedAt: string;
      status: "Active" | "Pending" | "Inactive";
      role: "Viewer" | "Operator" | "Admin";
    }[]
  ) => void;
  deleteUserManagementUsers(accountId: string, email: string): void;
};

export const userManagementInitialState = {
  userManagementUsers: {
    "75deb16f-d772-4648-9adb-06a555d33adc": [
      {
        name: "Mads Jensen",
        email: "mads.jensen@example.dk",
        updatedAt: "2025-09-26T10:57:14Z",
        status: "Active",
        role: "Admin",
      },
      {
        name: "Astrid Kristensen",
        email: "astrid.kristensen@example.dk",
        updatedAt: "2025-09-22T10:57:14Z",
        status: "Pending",
        role: "Operator",
      },
      {
        name: "Jonas Sørensen",
        email: "jonas.soerensen@example.dk",
        updatedAt: "2025-09-24T10:57:14Z",
        status: "Inactive",
        role: "Viewer",
      },
      {
        name: "Emilie Lund",
        email: "emilie.lund@example.dk",
        updatedAt: "2025-09-13T10:57:14Z",
        status: "Active",
        role: "Viewer",
      },
    ],
  } as {
    [accountId: string]: {
      name: string;
      email: string;
      updatedAt: string;
      status: "Active" | "Pending" | "Inactive";
      role: "Viewer" | "Operator" | "Admin";
    }[];
  },
} as UserManagementSlice;

export const createUserManagementSlice: StateCreator<
  UserManagementSlice,
  [],
  [],
  UserManagementSlice
> = (set) =>
  ({
    ...userManagementInitialState,
    setUserManagementUsers: (
      accountId: string,
      users: {
        name: string;
        email: string;
        updatedAt: string;
        status: "Active" | "Pending" | "Inactive";
        role: "Viewer" | "Operator" | "Admin";
      }[]
    ) => {
      set(({ userManagementUsers }) => {
        return {
          userManagementUsers: { ...userManagementUsers, [accountId]: users },
        };
      });
    },
    deleteUserManagementUsers: (accountId: string, email: string) => {
      set(({ userManagementUsers }) => {
        const users = (userManagementUsers[accountId] || []).filter(
          (user) => user.email !== email
        );
        return {
          userManagementUsers: { ...userManagementUsers, [accountId]: users },
        };
      });
    },
  } as UserManagementSlice);
